//合并业务配置
// import MY_CONFIG from "./myConfig"

// @ts-ignore
const env = Object.assign({}, import.meta.env, process.env || {});

const toBoolean = function (value) {
  if (typeof value === "string") {
    if (value === "true") {
      return true;
    }
    if (value === "false") {
      return false;
    }
  }
  return !!value;
}

const AMEND_API_URL = function (value) {
  if (/^http/i.test(value)) {
    return value;
  }
  if (/^\/\//i.test(value)) {
    return value;
  }
  if (/^\/\w/i.test(value)) {
    return `${window.location.origin}${value}`;
  }
  return value;
}

const getDomain = function () {
  let domain;
  const hostName = window.location.hostname;
  if (hostName.includes("localhost")) {
    domain = hostName;
  } else if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostName)) {
    domain = hostName;
  } else {
    const list = hostName.split(".");
    domain = list.slice(-2).join(".");
  }
  return {
    VITE_DOMAIN: domain,
    VITE_LQA: `//${env.VITE_LQA}.${domain}`,
    VITE_LQC: `//${env.VITE_LQC}.${domain}`,
  }
}


const DEFAULT_CONFIG = {
  env,
  ...getDomain(),
  TOKEN_KEY: "TOKEN",
  TOKEN_STANDBY: "TokenStandby",
  VITE_APP_DEBUG: toBoolean(env.VITE_APP_DEBUG),
  // 标题
  APP_NAME: env.VITE_APP_TITLE,

  // luckysheet 页面
  LUCKYSHEET_URL: env.VITE_APP_LUCKYSHEET || "/excel.html",
  // 图片预览地址
  PREVIEW_IMAGE: "https://preview.svon.org/image",
  PREVIEW_DOMAIN: "https://lqabaseout.oss-ap-southeast-1.aliyuncs.com",

  // 登录地址
  LOGIN_URL: "/login",
  // 退出
  LOGOUT_URL: "/logout",

  // 404
  EMPTY_URL: "/404",

  // 首页地址
  DASHBOARD_URL: "/dashboard",

  // 版本号
  APP_VER: "1.0.0",

  // 内核版本号
  CORE_VER: "1.0.0",

  // 接口地址
  // API_URL: env.NODE_ENV === 'development' && env.VUE_APP_PROXY === 'true' ? "/api" : env.VUE_APP_API_BASEURL,
  API_URL: AMEND_API_URL(env.API_BASEURL),

  // 请求超时
  TIMEOUT: 1000 * 20,

  // TokenName
  TOKEN_NAME: "Authorization",

  // Token前缀，注意最后有个空格，如不需要需设置空字符串
  TOKEN_PREFIX: "Bearer ",

  // 追加其他头
  HEADERS: {},

  // 请求是否开启缓存
  REQUEST_CACHE: false,

  // 布局 默认：default | 通栏：header | 经典：menu | 功能坞：dock
  // dock将关闭标签和面包屑栏
  LAYOUT: 'dock',

  // 菜单是否折叠
  MENU_IS_COLLAPSE: false,

  // 菜单是否启用手风琴效果
  MENU_UNIQUE_OPENED: false,

  // 是否开启多标签
  LAYOUT_TAGS: true,

  // 语言
  LANG: 'zh-cn',

  // 主题颜色
  COLOR: '',

  // 是否加密localStorage, 为空不加密，可填写AES(模式ECB,移位Pkcs7)加密
  LS_ENCRYPTION: '',

  // localStorageAES加密秘钥，位数建议填写8的倍数
  LS_ENCRYPTION_key: '2XNN4K8LC0ELVWN4',

  // 控制台首页默认布局
  DEFAULT_GRID: {
    // 默认分栏数量和宽度 例如 [24] [18,6] [8,8,8] [6,12,6]
    layout: [12, 6, 6],
    // 小组件分布，com取值:views/home/components 文件名
    copmsList: [
      ['welcome'],
      ['about', 'ver'],
      ['time', 'progress']
    ]
  }
}

// Object.assign(DEFAULT_CONFIG, MY_CONFIG);

// 如果生产模式，就合并动态的APP_CONFIG
// public/config.js
// if(env.NODE_ENV === 'production'){
// 	Object.assign(DEFAULT_CONFIG, true);
// }

export default DEFAULT_CONFIG
